export enum ModalTypes {
  Alert = 1,
  Confirm = 2,
  Custom = 3
}
